export default __webpack_public_path__ + "185e023aa1f996ae2c763620c9ef1547.svg";